/**
 * Override del Header de TZU.
 * Los créditos y la organización se muestran en el desplegable de UserMenu.
 */
import React from "react";
import { Badge, Flex, HStack, Text, VStack } from "@chakra-ui/react";
import LanguageSwitcher from './LanguageSwitcher';
import Logo from './Logo';
import UserMenu from './UserMenu';
import Navigation from './Navigation';
import { APP_NAME } from '../config/runtime';

import {
  headerContainer,
  contentContainer,
  topRowContainer
} from '../styles/HeaderStyles';

const Header = ({ onLogout }) => {
  return (
    <Flex {...headerContainer}>
      <Flex {...contentContainer}>
        {/* Logo + nombre */}
        <HStack {...topRowContainer}>
          <Logo />
          <VStack spacing={0} align="flex-start" lineHeight="1.05">
            <Text fontWeight="bold" fontSize="md" color="indigo.700">
              {APP_NAME}
            </Text>
            <Badge
              colorScheme="orange"
              variant="subtle"
              px={2}
              py={0.5}
              borderRadius="full"
              fontSize="0.6em"
              alignSelf="flex-start"
              mt={0.5}
            >
              Beta
            </Badge>
          </VStack>
        </HStack>

        {/* Links de navegación */}
        <Navigation />

        {/* Idioma y usuario */}
        <HStack
          spacing={2}
          flexShrink={0}
          ml={{ base: "auto", md: 0 }}
          order={{ base: 2, md: 0 }}
        >
          <LanguageSwitcher />
          <UserMenu />
        </HStack>
      </Flex>
    </Flex>
  );
};

export default Header;
